import { SerializedStyles } from "@emotion/react";
import { ReactNode, Ref, memo, useCallback } from "react";
import { usePartialSubmit } from "src/apps/AppFlow/pages/hooks";
import { FinePrint, FormFlowPage } from "src/components";
import { MaritalStatusValue } from "src/types/Application";
import { noInput } from "src/utilities/input";

import { formatters } from "@fraction/shared";

import { MaritalStatusDropdown } from "./components";

export interface MaritalStatusProps {
  firstName?: string;
  moreThanOneApplicant?: boolean;

  onChange: (value: MaritalStatusValue) => void;
  value?: MaritalStatusValue;
  focusRef?: Ref<HTMLInputElement>;
  onNext: () => void;
  onBack: () => void;
  style?: SerializedStyles;
  children?: ReactNode;
}

const MaritalStatus = ({
  onChange,
  value,
  firstName,
  moreThanOneApplicant,
  focusRef,
  onNext,
  onBack,
  style,
  children,
  ...props
}: MaritalStatusProps) => {
  const validate = useCallback(() => !noInput(value?.maritalStatus), [value]);
  const { handleNext, nextDisabled, nextLoading } = usePartialSubmit({ onNext, validate });
  const possessiveFirstName = formatters.user.possessive(firstName);
  const title = moreThanOneApplicant
    ? `What is ${possessiveFirstName} marital status?`
    : "What is your marital status?";

  return (
    <FormFlowPage
      {...props}
      title={title}
      description={undefined}
      onNext={handleNext}
      onBack={onBack}
      style={style}
      nextDisabled={nextDisabled}
      nextLoading={nextLoading}
    >
      <MaritalStatusDropdown onChange={onChange} value={value} focusRef={focusRef} />
      <FinePrint>
        Unmarried status includes: Single, Divorced, Civil Union, Domestic Partnership, Registered Reciprocal
        Beneficiary Relationship.
      </FinePrint>
      {children}
    </FormFlowPage>
  );
};

export default memo(MaritalStatus);
